import GlobalAttributeModal from "./GlobalAttributeModal";

export default GlobalAttributeModal;
